<template>
  <div class="full d-flex justify-center">
    <div class="to_home pa-2">
      <a href="https://temanbakat.id/" style="text-decoration: none">
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <img
              v-bind="attrs"
              v-on="on"
              src="https://temanbakat.id/welcome/wp-content/uploads/2021/08/Logo-Teman-Bakat-Baru-1-1-150x150.png"
              height="70px"
              alt=""
            />
          </template>
          <span>Back To Home</span>
        </v-tooltip>
      </a>
    </div>
    <div class="breakpoint d-flex align-center justify-center">
      <div class="intro">
        <div class="bg_base">
          <div class="temp_wave">
            <img
              src="../assets/img/V.1 020921 Journey Background Wave Comp0.png"
              width="100%"
              alt=""
            />
          </div>
          <div class="temp_result">
            <div class="mb-3">
              <v-btn
                text
                class="text-capitalize"
                color="purple"
                to="/journey/roadmap"
                ><v-icon>mdi-arrow-left</v-icon> Back to Journey</v-btn
              >
            </div>
            <section class="logo d-flex justify-center">
              <img
                src="../assets/img/logo-teman-bakat.png"
                height="90px"
                alt=""
              />
            </section>
            <section class="pa-3">
              <h3>Selamat! Registrasi kamu berhasil.</h3>
              <h3>
                Data Journey kamu bisa di download melalui aplikasi
                <b>Teman</b> bakat!
              </h3>
            </section>
            <div class="temp_ad">
              <section class="txt pa-3 d-flex align-center">
                <div>
                  <h3>Download aplikasinya di :</h3>
                  <div>
                    <a
                      href="https://play.google.com/store/apps/details?id=com.temanbakat"
                      target="_blank"
                      style="text-decoration: none"
                    >
                      <img
                        src="../assets/img/Googleplay-button0.png"
                        height="40px"
                        alt=""
                      />
                    </a>
                  </div>
                </div>
              </section>
              <div class="temp_img d-flex justify-end">
                <img
                  src="../assets/img/V.1 290821 Temanbakat.id - Ilsutrasi 50.png"
                  height="400px"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "thanks",
  data() {
    return {
      result: "",
      pyramid: {},
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped>
.bg_base {
  position: relative;
  background: url("../assets/img/Misi1-3-2Report Background.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  min-height: 100vh;
  width: 100%;
}
.logo {
  margin-bottom: 30px;
}
.temp-pyramid {
  position: relative;
}
.type {
  width: 100%;
  position: absolute;
  display: flex;
  justify-content: center;
  margin-top: 15px;
}
.temp_wave {
  top: 0;
  position: absolute;
}
.temp_result {
  position: relative;
  z-index: 2;
}
.temp_ad {
  position: relative;
}
.txt {
  position: absolute;
  width: 70%;
}
.temp_img {
  width: 100%;
  /* background: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)); */
}
</style>
